module.exports = __webpack_public_path__ + "img/TactileIndicator.1e826bbc.png";